import React, { useState, useEffect } from 'react';
import { Information } from '../../../../../components';

export const BuroRejected = () => {
  const [title, setTitle] = useState('');
  useEffect(() => {
    setTitle('En este momento no podemos hacerte un oferta. Te sugerimos intentar de nuevo en 90 días');
  }, []);

  return (
    <Information
      title={title}
    />
  );
};
